import * as actionTypes from '../types';

export const putUgAccountSettingsStart = () => ({
    type: actionTypes.PUT_UG_ACCOUNT_SETTINGS_START,
});

export const putUgAccountSettingsSuccess = (data) => ({
    type: actionTypes.PUT_UG_ACCOUNT_SETTINGS_SUCCESS,
    data,
});

export const putUgAccountSettingsFail = (error) => ({
    type: actionTypes.PUT_UG_ACCOUNT_SETTINGS_FAIL,
    error,
});

export const putUgAccountSettings = (data) => ({
    type: actionTypes.PUT_UG_ACCOUNT_SETTINGS,
    data,
});
